var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsReceptor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3408_123929)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00026 1.60026C11.5349 1.60026 14.4003 4.46564 14.4003 8.00026C14.4003 11.5349 11.5349 14.4003 8.00026 14.4003C4.46564 14.4003 1.60026 11.5349 1.60026 8.00026C1.60026 4.46564 4.46564 1.60026 8.00026 1.60026ZM8.00026 4.00026C5.79112 4.00026 4.00026 5.79112 4.00026 8.00026C4.00026 10.2094 5.79112 12.0003 8.00026 12.0003C10.2094 12.0003 12.0003 10.2094 12.0003 8.00026C12.0003 5.79112 10.2094 4.00026 8.00026 4.00026ZM8 0C8.44183 0 8.8 0.358172 8.8 0.8V7.2H15.2C15.6418 7.2 16 7.55817 16 8C16 8.44183 15.6418 8.8 15.2 8.8H8.8V15.2C8.8 15.6418 8.44183 16 8 16C7.55817 16 7.2 15.6418 7.2 15.2V8.8H0.8C0.358172 8.8 0 8.44183 0 8C0 7.55817 0.358172 7.2 0.8 7.2H7.2V0.8C7.2 0.358172 7.55817 0 8 0Z",
    fill: "#4C5E6E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3408_123929"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsReceptor);
export default __webpack_public_path__ + "static/media/icons_receptor.d5306be2.svg";
export { ForwardRef as ReactComponent };